<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'STREETS', url: '/admin/streets' },
    { label: 'CREATE_STREET' }
  ]"
></breadcrumbs>

<page-header title="CREATE_STREET"></page-header>

<card>
  <form class="form" (submit)="onSubmit($event)">
    <div class="field is-narrow">
      <label class="label" translationEditableDirective="NAME">{{
        'NAME' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="name"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['name'])"
          [ngClass]="{ 'is-danger': hasError('name') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('name')">
        {{ getError('name') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="STREET_TYPE">{{
        'STREET_TYPE' | translate
      }}</label>
      <div class="control">
        <ng-select
          class="is-small"
          [items]="streetTypes"
          [multiple]="false"
          [closeOnSelect]="true"
          (change)="handleFieldChange($event?.id, 'streetTypeId')"
          [ngClass]="{ 'is-danger': hasError('streetTypeId') }"
          bindLabel="name"
          bindValue="id"
          [ngModelOptions]="{ standalone: true }"
          [ngModel]="getField(['streetTypeId'])"
        >
        </ng-select>
      </div>
      <p class="help is-danger" *ngIf="hasError('streetTypeId')">
        {{ getError('streetTypeId') }}
      </p>
    </div>
  </form>
</card>

<div class="field is-grouped px-3">
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      (click)="onSubmit($event)"
      translationEditableDirective="SUBMIT"
    >
      {{ 'SUBMIT' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="['/admin/streets']"
      class="button is-link is-light"
      translationEditableDirective="CANCEL"
    >
      {{ 'CANCEL' | translate }}
    </a>
  </div>
</div>
